import { computed, reactive, toRefs } from 'vue'
import { useSearch } from './useSearch'

const state = reactive({
  paginationArray: [],
  defaultInitialPages: 3,
})

export function usePagination() {
  let { numPages, currentPage, loadSearch } = useSearch()
  function decoratorArray(length) {
    return Array.from({ length: length }, (_, i) => i + 1)
  }

  function splicePage() {
    if (numPages.value >= 6) {
      if (currentPage.value <= 3) {
        state.paginationArray = [
          ...decoratorArray(state.defaultInitialPages),
          '...',
          numPages.value,
        ]
      } else if (currentPage.value <= numPages.value - 3) {
        state.paginationArray = [
          1,
          '...',
          currentPage.value - 1,
          currentPage.value,
          currentPage.value + 1,
          '...',
          numPages.value,
        ]
      } else {
        state.paginationArray = [
          1,
          '...',
          numPages.value - 2,
          numPages.value - 1,
          numPages.value,
        ]
      }
    }
  }

  function loadPagination() {
    if (numPages.value < 6 && numPages.value > 1) {
      state.paginationArray = decoratorArray(numPages.value)
    } else {
      state.paginationArray = [
        ...decoratorArray(state.defaultInitialPages),
        '...',
        numPages.value,
      ]
    }
  }

  function activeIndex(index) {
    return index === currentPage.value
  }

  function changePage(value) {
    if (value !== '...') {
      updatePage(value)
      splicePage(numPages.value)
    }
  }

  async function updatePage(payload) {
    currentPage.value = payload
    await loadSearch()
  }

  function prevPage() {
    updatePage(currentPage.value - 1)
    splicePage(numPages.value)
  }
  function nextPage() {
    updatePage(currentPage.value + 1)
    splicePage(numPages.value)
  }

  const disablePrev = computed(() => {
    return currentPage.value === 1
  })
  const disableNext = computed(() => {
    return currentPage.value === numPages.value
  })

  return {
    ...toRefs(state),
    currentPage,
    splicePage,
    decoratorArray,
    disablePrev,
    disableNext,
    loadPagination,
    activeIndex,
    changePage,
    prevPage,
    nextPage,
    updatePage,
    numPages,
  }
}
